/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
// --------------- Traduction --------------------
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
// -------- Historiques + Parametre URL ---------
import { useHistory, useParams } from "react-router";
import ErrorAlert from "../../others/ErrorAlert";
// -------- WEB SERVICES ---------
import { detailchargement, converttoChargement } from "../../services/Notification/notificationApi";
//--------- Components --------------------------
import Loader from "../../components/shared/Loader";
import {
  SearchItems,
  sortPricettcAsc,
  sortPricettcDesc,
  TrierAZlibelle,
} from "../../utils/SearchUtils";
import { OverlayTrigger } from "react-bootstrap";
import { popover3 } from "../../components/Popover/Popovertab";

export default function DetailChargement() {
  const { code } = useParams();
  const history = useHistory();

  //------ State -----------  
  const inputEl = useRef("");
  const [chargement, setchargement] = useState([]);
  const [searchList, setSearchlist] = useState([]);
  const [saveList, setSaveList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setloading] = useState(true);
  const [alerte, setalerte] = useState(false);
  const [search, setSearch] = useState("");
  const [value, setValue] = useState(0);
  const [t, i18n] = useTranslation("global");

  // current posts = recherche ou liste principale
  const currentPosts = search.length < 2 ? chargement : searchList;

  // ==========================
  // 📌 LOAD INIT DATA
  // ==========================
  useEffect(() => {
    detailchargement(code)
      .then((res) => {
        const items = res?.data?.details || [];

        // recalcul total
        const total = items.reduce(
          (sum, { quantite, prix_ttc }) =>
            sum + parseFloat(quantite) * parseFloat(prix_ttc),
          0
        );

        setTotal(total);
        setchargement(items);
        setSaveList(items);
      })
      .catch((err) => console.log(err))
      .finally(() => setloading(false));
  }, []);

  // ==========================
  // 📌 CONVERT CHARGEMENT
  // ==========================
  const handleConvertChargement = async () => {
    try {
      const response = await converttoChargement(code);

      if (response.status === 200) {
        toast(t("données enregistré avec succès"), {
          type: "success",
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        history.push("/demande_chargement");
      } else {
        toast.error(t("toast.erreurChargement") || "Erreur lors de la conversion !");
        setalerte(true);
      }
    } catch (err) {
      toast.error(t("toast.erreurChargement") || "Erreur inattendue !");
      setalerte(true);
    }
  };

  // ==========================
  // 📌 SEARCH FUNCTION
  // ==========================
  const getSearchTerm = () => {
    const term = inputEl.current.value;
    setSearch(term);

    if (term.length >= 2) {
      const list = SearchItems(saveList, term);
      setSearchlist(list);

      const ttt = list.reduce(
        (sum, { quantite, prix_ttc }) =>
          sum + parseFloat(quantite) * parseFloat(prix_ttc),
        0
      );
      setTotal(ttt);
    } else {
      setchargement(saveList);

      const ttt = saveList.reduce(
        (sum, { quantite, prix_ttc }) =>
          sum + parseFloat(quantite) * parseFloat(prix_ttc),
        0
      );
      setTotal(ttt);
    }
  };

  // ==========================
  // 📌 CHANGER LA QUANTITÉ
  // ==========================
  const handleQuantiteChange = (index, newValue) => {
    setchargement((prev) =>
      prev.map((item, i) =>
        i === index
          ? { ...item, quantite: parseFloat(newValue) || 0 }
          : item
      )
    );

    // recalc total
    const updated = currentPosts.map((item, i) =>
      i === index
        ? { ...item, quantite: parseFloat(newValue) || 0 }
        : item
    );

    const ttt = updated.reduce(
      (sum, { quantite, prix_ttc }) =>
        sum + parseFloat(quantite) * parseFloat(prix_ttc),
      0
    );

    setTotal(ttt);
  };

  // ==========================
  // 📌 TRIER ELEMENT
  // ==========================
  function ChangeElement(e) {
    setloading(true);

    const val = e.target.value;
    setValue(val);

    let list = search.length < 2 ? [...chargement] : [...searchList];

    if (val === "1") sortPricettcAsc(list);
    else if (val === "2") sortPricettcDesc(list);
    else if (val === "3") TrierAZlibelle(list);

    if (search.length < 2) setchargement(list);
    else setSearchlist(list);

    setloading(false);
  }

  // ================================================
  // 📌 RENDER JSX
  // ================================================
  return (
    <div dir={i18n.dir()}>
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* Bouton retour */}
          <div className="section-title">
            <button className="btn bg-primary" onClick={() => history.goBack()}>
              <i className="fe fe-arrow-left" /> {t("stock.retour")}
            </button>
          </div>

          {/* SECTION TITRE */}
          <div className="row">
            <div className="col-md-12">
              <div
                className="panel-group"
                id="accordion1"
                role="tablist"
                aria-multiselectable="true"
                style={{ marginBottom: "10px" }}
              >
                <div className="panel panel-default active">
                  <div className="panel-heading" role="tab" id="headingOne">
                    <h4 className="panel-title mobiletext">
                      <a
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion1"
                        href="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <i className="icon icon-grid text-primary mr-2" />{" "}
                        {t("chargement.detailchargement")}
                        <span className="float-right">
                          {" "}
                          <i className="fe fe-search text-primary" />{" "}
                        </span>
                      </a>
                    </h4>
                  </div>

                  {/* COLLAPSE SECTION */}
                  <div
                    id="collapseOne"
                    className="panel-collapse collapse"
                    role="tabpanel"
                  >
                    <div className="panel-body">
                      {/* BARRE DE TRI + SEARCH */}
                      <div
                        className="item2-gl-nav bg-white d-flex"
                        style={{ marginBottom: "20px" }}
                      >
                        {/* TRIER */}
                        <div className="col-md-6 col-12">
                          <div className="d-flex">
                            <label className="mr-2 mt-1 mb-sm-1">
                              {t("stock.trierpar")}{" "}
                              <i className="ti-exchange-vertical" />
                            </label>
                            <select
                              className="form-control nice-select mb-0 nice-select-md w-170"
                              value={value}
                              onChange={(e) => ChangeElement(e)}
                            >
                              <option value={0}>
                                ------- {t("stock.trierpar")} -----
                              </option>
                              <option value={1}>
                                {t("stock.prixcroissant")}
                              </option>
                              <option value={2}>
                                {t("stock.prixdecroissant")}
                              </option>
                              <option value={3}>A-Z</option>
                            </select>
                          </div>
                        </div>

                        {/* SEARCH */}
                        <div className="col-md-6 col-12">
                          <div className="search1 search-elements-sm">
                            <div className="form row no-gutters">
                              <div className="form-group col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10 mb-0">
                                <input
                                  type="text"
                                  ref={inputEl}
                                  className="form-control"
                                  placeholder={t("stock.search")}
                                  value={search}
                                  onChange={getSearchTerm}
                                />
                              </div>
                              <div className="col-xl-2 col-lg-2 col-md-2 col-2 mb-0">
                                <button
                                  className="btn btn-block btn-success"
                                  onClick={getSearchTerm}
                                >
                                  <i className="fe fe-search" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* END BARRE */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* TABLEAU */}
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive push">
                    <table className="table table-bordered table-striped table-hover tutorial-table">
                      <tbody>
                        <tr className="text-center">
                          <th>{t("stock.code")}</th>
                          <th>{t("stock.commercial")}</th>
                          <th>{t("releve.produit")}</th>
                          <th>{t("todayCommercial.stock")}</th>
                          <th>{t("stock.qte")}</th>
                          <th>{t("stock.total")}</th>
                        </tr>

                        {currentPosts?.map((item, index) => (
                          <tr key={index} className="text-center">
                            <td>{item.produit_code}</td>
                            <td>{item.nom}</td>
                            <td>{item.libelle}</td>
                            <td>{item.stocks}</td>

                            <td>
                              <input
                                type="number"
                                className="form-control text-center"
                                value={item.quantite}
                                onChange={(e) =>
                                  handleQuantiteChange(index, e.target.value)
                                }
                              />
                            </td>

                            <td>
                              {(item.quantite * item.prix_ttc).toFixed(3)}
                            </td>
                          </tr>
                        ))}

                        {/* TOTAL */}
                        <tr>
                          <td colSpan="5" className="text-right font-w600">
                            {t("releve.totalttc")}
                          </td>
                          <td className="text-right">{total.toFixed(3)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* BUTTON VALIDER */}
                  <div className="col-xl-2 col-lg-3 col-md-4 col-12 mb-0">
                    <button
                      className="btn btn-success w-100"
                      onClick={handleConvertChargement}
                    >
                      {t("widget.valider")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {alerte && <ErrorAlert t={t} />}
    </div>
  );
}
